<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="合作商">
					<el-select v-model="listQuery.search.kh_uid" clearable placeholder="全部">
						<el-option v-for="item in kh_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:50px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="uid" label="合作商">
					<template slot-scope="{row}">
						<span v-if="row.kh_uid">{{row.kh_name}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_init" label="类型"> </el-table-column>
				<el-table-column prop="money" label="金额">
					<template slot-scope="{row}">
						<span v-if="row.sign == 1" style="color:#67C23A">+ {{row.money}}</span>
						<span v-else style="color:#F56C6C">- {{row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="balance" label="账户余额"> </el-table-column>
				<el-table-column prop="remarks" label="备注"> </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	import {
		reMoneyList,
		excelToken
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp,
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				currency: [], // 所有币种
				br_type: [], // 所有类型
				is_show_search: false,
				store_all: [], // 所有店铺
				role_body: '',
				kh_all: [],
				group_list:[], // 所有分组
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						sign: '',
						start_time: '',
						end_time: '',
						currency_type: '',
						type: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				reMoneyList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;

					if (this.listQuery.page == 1) {
						this.role_body = r.role_body;
						this.kh_all = r.kh_all;
					}

					this.loading = false;
				})
			},
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
